import React, { useState } from 'react';
import { IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router';
import useAxios from 'axios-hooks';
import { usePlan } from '../../../../hooks/usePlan';
import { useFeedback } from '../../../../hooks/useFeedback';
import { SUCCESS_FEEDBACK, ERROR_FEEDBACK } from '../../../../utilities/feedback';
import AlertBox from '../../../../components/AlertBox';

const Actions = ({ id, refetch }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [plan, setPlan] = usePlan();
  const isMenuOpen = Boolean(anchorEl);
  const [, setFeedback] = useFeedback();
  const navigate = useNavigate();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const [, destroyApp] = useAxios(
    {
      url: `${process.env.REACT_APP_API_URL}/apps/${id}`,
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    },
    { manual: true }
  );

  const deleteApp = () => {
    destroyApp()
      .then(() => {
        setFeedback(
          SUCCESS_FEEDBACK({
            message: 'App removed',
          })
        );
        setPlan({ ...plan, app_counter: plan.app_counter - 1 });
        refetch();
      })
      .catch((err) =>
        setFeedback(
          ERROR_FEEDBACK({
            message: err.response.data.error,
          })
        )
      );
    setOpen(false);
  };

  return (
    <>
      <AlertBox
        open={open}
        onClose={() => setOpen(false)}
        submit={deleteApp}
        title="Are you sur ?"
        text="Do you want to remove this app ?"
        canceltext="Cancel"
        submitText="Delete"
      />
      <IconButton onClick={handleMenuOpen} size="large">
        <MoreVertIcon color="secondary" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => navigate(`/app/apps/${id}/edit`)}>
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          Edit
        </MenuItem>
        <MenuItem onClick={() => setOpen(true)}>
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};
export default Actions;
